
   // @ts-nocheck
   import { Options, Vue } from "vue-class-component";
   import { mapState, mapMutations } from "vuex";
   import COVERAPP from "@/utils/COVERAPP";
   import gameHome from "../components/game-home.vue";
   @Options({
      components: {
         gameHome,
      },
      data() {
         return {
            isloading: true,
            timer: null,
            isShowVideo: false,
            loading: "",
            posterImg: require("../../static/video/video_img.png"),
            playStatus: false,
            tiaoguoStatus: false,
            sharedata: [
               "大国工程我来建｜最新出炉全国省份手速排行",
               "限时开放！“大国工程我来建”游戏挑战赛，积分有好礼",
               "十月必玩小游戏！“大国工程我来建”震撼登场",
               "十月第一份惊喜！你有一份来自大国工程的礼物待签收",
               "大国工程我来建｜这次，为梦想拼手速！",
            ],
         };
      },
      computed: {
         ...mapState([
            "userInfo",
            "shareData",
            "activityData",
            "GetUserParams",
            "isFirstlogin",
         ]),
      },
      mounted() {
         const _this = this;
         if (COVERAPP.Attribute.isApp) {
            try {
               _this.playStatus = false;
               var video = document.getElementById("videoM3u8");
               const a = document.getElementById("BGMbtn_id");
               video.addEventListener("playing", function () {
                  _this.tiaoguoStatus = true;
               });
               video.addEventListener("ended", function () {
                  a.style = "display:flex";
                  _this.isShowVideo = false;
                  localStorage.setItem("isVideo", false);
               });
            } catch (e) {
               console.log(e);
            }
         }
         this.$common.pageLoaded();
         let homeShareData = JSON.parse(JSON.stringify(this.shareData));
         homeShareData.link = window.location.href;
         this.isShowVideo = JSON.parse(localStorage.getItem("isVideo"));
      },
      created() {
         const _this = this;
         let homeShareData = JSON.parse(JSON.stringify(_this.shareData));
         homeShareData.link = "https://activity.thepage.cn/dggcwlj/";
         let shareindex = Math.round(Math.random() * 4);
         let desc = _this.sharedata[shareindex];
         homeShareData.title = desc;
         homeShareData.desc = "";
         _this.$common.onshare(JSON.parse(JSON.stringify(homeShareData)));
         this.gameinfo();
         this.isShowVideo = JSON.parse(localStorage.getItem("isVideo"));
         const a = document.getElementById("BGMbtn_id");
         if (this.isShowVideo) {
            try {
               a.style = "display:none";
            } catch (e) {}
         } else {
            try {
               a.style = "display:flex";
            } catch (e) {}
         }
         if (COVERAPP.Attribute.isAndroid()) {
            _this.playStatus = true;
            document.addEventListener(
               "touchstart",
               function () {
                  let myVid = document.getElementById("videoM3u8");
                  if (myVid) {
                     try {
                        myVid.play();
                        _this.playStatus = false;
                     } catch (e) {}
                     myVid.addEventListener("playing", function () {
                        _this.tiaoguoStatus = true;
                     });
                     myVid.addEventListener("ended", function () {
                        try {
                           a.style = "display:flex";
                        } catch (e) {}
                        _this.isShowVideo = false;
                        localStorage.setItem("isVideo", false);
                     });
                  }
               },
               false
            );
         } else if (COVERAPP.Attribute.isIOS()) {
            document.addEventListener("WeixinJSBridgeReady", function () {
               let myVid = document.getElementById("videoM3u8");
               if (myVid) {
                  _this.playStatus = false;
                  try {
                     myVid.play();
                  } catch (e) {}
                  myVid.addEventListener("playing", function () {
                     _this.tiaoguoStatus = true;
                  });
                  myVid.addEventListener("ended", function () {
                     try {
                        a.style = "display:flex";
                     } catch (e) {}
                     _this.isShowVideo = false;
                     localStorage.setItem("isVideo", false);
                  });
               }
            });
         } else {
            console.log("PC");
            this.playerVideo();
            return;
         }
      },
      methods: {
         ...mapMutations(["SET_SHOWAPPBTN"]),
         async gameinfo() {
            let usr = sessionStorage.getItem("COVER_USERINFO");
            var user;
            if (usr != null) {
               user = JSON.parse(usr);
            }
            let usrdata = await this.$request(
               "/temporary/dggcwlj/user",
               { aid: "631ff5bf43b09f005038d8bd", userinfo: user },
               "post"
            ).catch((res) => {
               console.log("用户游戏信息测试数据错误", res);
            });
            sessionStorage.setItem("GAME_USERINFO", JSON.stringify(usrdata));
         },

         createTouchstartEventAndDispatch(el) {
            let event = document.createEvent("Events");
            event.initEvent("touchstart", true, true);
            el.dispatchEvent(event);
         },
         // 关闭视频组件
         playerVideo() {
            const a = document.getElementById("BGMbtn_id");
            a.style = "display:none";

            this.SET_SHOWAPPBTN(false);
            this.playStatus = false;
            let myVid = document.getElementById("videoM3u8");
            /* myVid.play();
            const _this = this;
            myVid.addEventListener("ended", function () {
               a.style = "display:flex";
               _this.isShowVideo = false;
               localStorage.setItem("isVideo", false);
            }); */
         },
         closeVideo() {
            const a = document.getElementById("BGMbtn_id");
            a.style = "display:flex";
            this.isShowVideo = false;
            localStorage.setItem("isVideo", false);
         },
      },
   })
   export default class Home extends Vue {}
